import { AdaptiveSheet } from '../common/AdaptiveSheet';
import { BundleVendorsView } from './BundleVendorsView.web';

// Tablet host for BundleVendorsView. The desktop shell puts the
// same view in a CompanionPanel instead (DefensePlanPanel.web.tsx branches on
// useDesktopShell()), the way it does for bids.
export function DefensePlanVendorsSheet({
  visible,
  planId,
  bundleId,
  onClose,
}: {
  visible: boolean;
  planId: string | null;
  bundleId: string | null;
  onClose: () => void;
}) {
  return (
    <AdaptiveSheet isOpen={visible} onRequestClose={onClose} onDismiss={onClose} dialogWidth={480}>
      <AdaptiveSheet.ScrollView testID="plan-vendors-sheet">
        {planId && bundleId ? <BundleVendorsView planId={planId} bundleId={bundleId} /> : null}
      </AdaptiveSheet.ScrollView>
    </AdaptiveSheet>
  );
}
